import BankRegistPage from './BankRegistPage';

export default BankRegistPage;
